import { fetcher } from "helpers/fetcher";

import { TExportActiveVacanciesReq, TExportActiveVacanciesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const exportActiveVacancy = async (
  payload?: TExportActiveVacanciesReq
) => {
  return await fetcher<TExportActiveVacanciesRes, TExportActiveVacanciesReq>(
    ENDPOINT.CORPORATION.EXPORT_ACTIVE_VACANCY,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.EXPORT_ACTIVE_VACANCY.version,
        [API_HEADER.CORP_ID]: payload?.idCorporation,
        [API_HEADER.BU_ID]: payload?.idBusinessUnit,
      },
    }
  );
};

export const mutationExportActiveVacancy = async (
  payload?: TExportActiveVacanciesReq
) => {
  return (await exportActiveVacancy(payload)).data;
};

mutationExportActiveVacancy._key = (payload?: TExportActiveVacanciesReq) => [
  ENDPOINT.CORPORATION.EXPORT_ACTIVE_VACANCY.url,
  payload,
];
